// Angular
import { Component, ViewChild, ViewContainerRef } from '@angular/core';

// Formly
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'formly-wrapper-section',
    templateUrl: './section.wrapper.component.html',
    styleUrls: ['./section.wrapper.component.scss'],
})
export class SectionWrapperComponent extends FieldWrapper {
    @ViewChild('fieldComponent', { static: true, read: ViewContainerRef }) fieldComponent: ViewContainerRef;
}
